import React from "react";
import styles from "./CustomMessage.module.scss";
import { InfoFilled } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/InfoFilled";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

interface Props {
  type?: "default" | "information" | "warning" | "error" | "success";
  title?: string;
  text?: string;
  link?: string;
  linkUrl?: string;
  dataTestId?: string;
  iconComponent?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  customClassName?: string;
  htmlContent?: React.ReactNode;
}

export const CustomMessage: React.FC<Props> = ({
  type = "default",
  title,
  text,
  link,
  linkUrl,
  dataTestId,
  iconComponent,
  customClassName,
  htmlContent,
}) => {
  const Icon = iconComponent || InfoFilled;

  return (
    <div
      data-testid={dataTestId || "custom-message"}
      className={`${cx("container", {
        information: type === "information",
        warning: type === "warning",
        error: type === "error",
        success: type === "success",
      })}${customClassName ? ` ${customClassName}` : ""}`}
    >
      <div>
        <Icon size="large" className={styles.icon} />
      </div>
      <div className={styles.content}>
        {title ? <h4 className={styles.title}>{title}</h4> : null}
        {text ? <p className={styles.text}>{text}</p> : null}
        {htmlContent ? (
          <div className={styles.htmlContent}>{htmlContent}</div>
        ) : null}
        {link && linkUrl ? (
          <a
            href={linkUrl}
            target="_blank"
            rel="noreferrer"
            className={styles.link}
          >
            {link}
          </a>
        ) : null}
      </div>
    </div>
  );
};

export default CustomMessage;
